import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'name', label: 'name', sortable: true },
    { key: 'code', label: 'Code', sortable: true },
    { key: 'category_subject', label: 'Category Subject', sortable: true },
    { key: 'actions' },
  ]

  return {
    tableColumns,
    ...tableConfig('organizationDirection', { perPage: 1000 }),
  }
}
